import { FC } from "react";
import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  UseFormSetError,
  UseFormClearErrors,
} from "react-hook-form";
import SelectField from "app/components/common/inputs/SelectField";
import InputField from "app/components/common/inputs/InputField";
import AutocompleteLocations from "app/components/common/AutocompleteLocations";
import FormGroup from "app/components/common/inputs/FormGroup";

import {
  maritalstatusOptions,
  stateOfIssueOptions,
  HousingStatusOptions,
  numberDependentsOptions,
} from "app/utils/staticValues";

interface Props {
  control: Control<any>;
  errors: any;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  setError: UseFormSetError<any>;
  clearErrors: UseFormClearErrors<any>;
  numberDependentsName: string;
  maritalStatusName: string;
  housingStatusName: string;
  addressStreetName: string;
  addressStateName: string;
  addressPostCodeName: string;
  isSameAddress?: boolean;
  disabledCoFields?: boolean;
}

const DynamicFormTwo: FC<Props> = ({
  control,
  errors,
  register,
  setValue,
  setError,
  clearErrors,
  numberDependentsName,
  maritalStatusName,
  housingStatusName,
  addressStreetName,
  addressStateName,
  addressPostCodeName,
  isSameAddress = false,
  disabledCoFields = false,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };

  return (
    <>
      <FormGroup>
        <SelectField
          label="Number of Dependents (Under 18)"
          name={numberDependentsName}
          control={control}
          options={numberDependentsOptions}
          placeholder="4"
          error={getErrorMessage(numberDependentsName)?.message as string}
          required={disabledCoFields ? false : true}
          className="flex-1"
          isDisabled={disabledCoFields}
        />
        <SelectField
          label="Marital status"
          name={maritalStatusName}
          control={control}
          options={maritalstatusOptions}
          placeholder="Please select marital status"
          error={getErrorMessage(maritalStatusName)?.message as string}
          required={disabledCoFields ? false : true}
          className="flex-1"
          isDisabled={disabledCoFields}
        />
      </FormGroup>

      <FormGroup>
        <SelectField
          label="What is your housing status?"
          name={housingStatusName}
          control={control}
          options={HousingStatusOptions}
          placeholder="Please select housing status"
          error={getErrorMessage(housingStatusName)?.message as string}
          required={disabledCoFields ? false : true}
          className="flex-1"
          isDisabled={disabledCoFields}
        />
      </FormGroup>

      <FormGroup>
        <AutocompleteLocations
          FieldName={addressStreetName}
          placeholder="1901 Thornridge Cir. Shiloh,"
          register={register}
          setValue={setValue}
          setError={setError}
          label="Current resident address"
          required={isSameAddress || disabledCoFields ? false : true}
          className="flex-1"
          error={getErrorMessage(addressStreetName)?.message as string}
          stateFieldName={addressStateName}
          postCodeFieldName={addressPostCodeName}
          clearErrors={clearErrors}
          disabled={isSameAddress || disabledCoFields}
        />
        <div className="flex-1">
          <FormGroup direction="row">
            <SelectField
              label="State"
              name={addressStateName}
              control={control}
              options={stateOfIssueOptions}
              placeholder="State"
              error={getErrorMessage(addressStateName)?.message as string}
              required={isSameAddress || disabledCoFields ? false : true}
              className="flex-1"
              menuPlacement="top"
              isDisabled={isSameAddress || disabledCoFields}
            />
            <InputField
              label="Post code"
              name={addressPostCodeName}
              control={control}
              type="number"
              required={isSameAddress || disabledCoFields ? false : true}
              placeholder="7870"
              error={getErrorMessage(addressPostCodeName)?.message as string}
              className="flex-1"
              disabled={isSameAddress || disabledCoFields}
            />
          </FormGroup>
        </div>
      </FormGroup>
    </>
  );
};

export default DynamicFormTwo;
